import { Component, OnInit } from '@angular/core';
import {
  Form,
  FormBuilder,
  FormGroup,
  NgForm,
  Validators,
} from '@angular/forms';
import { ApplicantService } from 'src/app/services/applicant.service';
import { LocationService } from 'src/app/services/location.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TosterService } from 'src/app/services/toster.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CoApplicantService } from 'src/app/services/co-applicant.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { noWhitespaceValidator } from 'src/shared/whitespace.validator';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-co-applicant',
  templateUrl: './co-applicant.component.html',
  styleUrls: ['./co-applicant.component.css'],
})
export class CoApplicantComponent implements OnInit {
  addMoresection: any = [{}];
  applicant: any = [{}];
  coApplicantForm!: FormGroup;
  appForms: any;
  isValidFormSubmitted: any;
  id: any;
  _id: any;
  udata: any;
  applicantSdata: any;
  statedata: any;
  districtdata: any;
  districtdataApplicant: any;
  districtdataContact: any;
  email: any;
  organizationNameVal: any = "";
  foodVal: any;
  AddressContact: any = { address: '', state: '', city: '', pincode: '' };
  /*****************************/
  Applicant_city: any = '';
  Applicant_state: any = '';
  pinError: any = '';
  pinStatus: any = true;
  /*****************************/
  con1_city: any = '';
  con1_state: any = '';
  con1Error: any = '';
  con1Status: any = true;
  /*****************************/
  con2_city: any = '';
  con2_state: any = '';
  con2Error: any = '';
  con2Status: any = true;
  sector: any;
  products: any;
  imageUrl: any;
  imageUrlUAM: any;
  uploadedimage: any;
  uploadedimageUAM: any;
  hightestRankingVal: any = "";
  designationVal: any = "";
  /*****************************/
  imageError: any = false;
  imageErrorMsg: any = '';
  imageUError: any = false;
  imageUAMError: any = '';
  coapp: any = [];
  FinalError: any = { errMsg: '', status: false };
  coapp_id: any;
  actionStatus: any;
  co_orgName: any;
  seccselectedItems: any = [];
  SectorPrevdropdownList: any = [];
  dropdownSettings: IDropdownSettings = {};
  countrydata: any;
  co_operationFormVal: any = "";
  co_operationEntityFormVal: any = "";
  co_emailVal: any = "";
  userStatus: boolean = false;
  url: any;
  formInitialized: boolean = false;
  isEditing: boolean = false;
  constructor(
    private fb: FormBuilder,
    private coapplicantS: CoApplicantService,
    private router: Router,
    private _Activatedroute: ActivatedRoute,
    private toast: TosterService,
    private locationS: LocationService,
    private spinner: NgxSpinnerService,
    private locat: LocationService,
    private applicantS: ApplicantService
  ) { }
  get f() {
    return this.coApplicantForm?.controls;
  }
  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_text',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
    };
    // this.onforminit()
    this.url = this.router.url.split('/');
    this.isEditing = this.url[1] == 'co-applicant';
    this.spinner.hide();
    this.udata = localStorage.getItem('userdata');
    this.udata = JSON.parse(this.udata);
    this.email = this.udata.email;
    this._id = this.udata._id;
    if (this.url[1] == 'co-applicant') {
      this.actionStatus = 'edit';
      this.coapp_id = this._Activatedroute.snapshot.paramMap.get('id');
      this.coapplicantS
        .getByIdCoApplicant(this.coapp_id)
        .subscribe((c_item: any) => {
          if (c_item.statusCode == 200 && c_item.coapplicantRecord) {
            this.userStatus = c_item.coapplicantRecord[0].userStatus
            this.coapp = c_item.coapplicantRecord[0];
            this.applicantS.getSector().subscribe((items: any) => {
              items.result.map((item: any) => {
                this.SectorPrevdropdownList.push({ item_text: item });
              });
              this.onforminit(this.coapp);
              this.co_orgName = this.coapp.co_organizationName;
              this.seccselectedItems = this.coapp.co_product;
              this.getStateByCountryName(this.coapp.co_applicantCountry, '');
              this.Setvalue(this.coapp.co_organizationName, 'co_organizationName', null)
              this.Setvalue(
                this.coapp.co_hightestRanking,
                'co_hightestRanking',
                null
              );
              this.Setvalue(this.coapp.co_Designation, 'co_Designation', null)
              this.Setvalue(
                this.coapp.co_operationForm,
                'co_operationForm',
                null
              );
              this.Setvalue(
                this.coapp.co_operationEntityFormVal,
                'co_operationEntityFormVal',
                null
              );
              this.Setvalue(
                this.coapp.co_email,
                'co_email',
                null
              );
              if (this.userStatus && !this.udata.role.includes('admin')) this.coApplicantForm.disable()
              // this.organizationNameVal = this.coapp.organizationName;
            });
          } else {
            this.actionStatus = 'add';
            this.applicantS.getSector().subscribe((items: any) => {
              items.result.map((item: any) => {
                this.SectorPrevdropdownList.push({ item_text: item });
              });
              this.onforminit(this.coapp);
            });
          }
        });
    } else {
      this.actionStatus = 'add';
      this.applicantS.getSector().subscribe((items: any) => {
        items.result.map((item: any) => {
          this.SectorPrevdropdownList.push({ item_text: item });
        });
        this.onforminit(this.coapp);
      });
    }
    this.locationS.getAllCountries().subscribe((data: any) => {
      this.countrydata = data.filter((item: any) => { if (item) return true; else return false; });
    });
    this.locationS.getallstates().subscribe((data: any) => {
      this.statedata = data.result.filter((item: any) => { if (item) return true; else return false; });
    });
  }
  getStateByCountryName(country: any, f: any) {
    let countryVal = f == 'sett' ? country.target.value : country;
    this.locationS.getStateByCountry(countryVal).subscribe((items: any) => {
      this.statedata = items[0].states;
    });
  }
  onItemSelectDropDown(item: any, dropdownName: any) {
    if (dropdownName == 'co_product') {
      this.seccselectedItems.push(item);
    }
  }
  onforminit(coapp: any) {
    this.coApplicantForm = this.fb.group({
      applicantId: coapp.applicantId || this._id,
      co_organizationName: [coapp.co_organizationName, [noWhitespaceValidator]],
      co_hightestRanking: [coapp.co_hightestRanking, [noWhitespaceValidator]],
      co_Designation: [coapp.co_Designation, [noWhitespaceValidator]],
      co_operationForm: [coapp.co_operationForm, [noWhitespaceValidator]],
      co_operationEntityFormVal: [coapp.co_operationEntityFormVal, [noWhitespaceValidator]],
      co_email: [
        coapp.co_email,
        [Validators.pattern('^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$')],
      ],
      co_mobileNo: [coapp.co_mobileNo, [noWhitespaceValidator]],
      co_applicantAddress1: [coapp.co_applicantAddress1, [noWhitespaceValidator]],
      co_applicantCountry: [coapp.co_applicantCountry, [noWhitespaceValidator]],
      co_applicantZipCode: [coapp.co_applicantZipCode, [noWhitespaceValidator]],
      co_applicantState: [coapp.co_applicantState, [noWhitespaceValidator]],
      co_applicantCity: [coapp.co_applicantCity, [noWhitespaceValidator]],
      co_contactPerson: [coapp.co_contactPerson, [noWhitespaceValidator]],
      co_contactDesignation: [coapp.co_contactDesignation, [noWhitespaceValidator]],
      co_contactEmail: [
        coapp.co_contactEmail,
        [Validators.pattern('^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$')],
      ],
      co_contactMobile: [coapp.co_contactMobile, [noWhitespaceValidator]],
      co_contactAddress1: [coapp.co_contactAddress1, [noWhitespaceValidator]],
      co_contactCountry: [coapp.co_contactCountry, [noWhitespaceValidator]],
      co_contactZipCode: [coapp.co_contactZipCode, [noWhitespaceValidator]],
      co_contactState: [coapp.co_contactState, [noWhitespaceValidator]],
      co_contactCity: [coapp.co_contactCity, [noWhitespaceValidator]],
      co_FoodCategoryNameNumber: [coapp.co_FoodCategoryNameNumber, [noWhitespaceValidator]],
      co_criteria: [coapp.co_criteria, [noWhitespaceValidator]],
      co_annualApplicant: [coapp.co_annualApplicant, [noWhitespaceValidator]],
      co_product: [this.seccselectedItems, [noWhitespaceValidator]],
      co_totalEmployee: [coapp.co_totalEmployee, [noWhitespaceValidator]],
      co_applicantEquipment: [coapp.co_applicantEquipment, [noWhitespaceValidator]],
      co_gst: [
        coapp.co_gst,
        [
          Validators.pattern(
            /^([0][1-9]|[1-2][0-9]|[3][0-7])([A-Z]{5})([0-9]{4})([A-Z]{1}[1-9A-Z]{1})([Z]{1})([0-9A-Z]{1})+$/
          ),
        ],
      ],
      co_tax_invoice: [coapp.co_tax_invoice, [noWhitespaceValidator]],
      co_billingAddress: [coapp.co_billingAddress, [noWhitespaceValidator]],
      annualApplicantRupee: [coapp.annualApplicantRupee, [noWhitespaceValidator]],
      code1: [coapp.code1, [noWhitespaceValidator]],
      code2: [coapp.code2, [noWhitespaceValidator]],
    });
    this.formInitialized = true;
    if (this.udata.role.includes('admin')) {
      this.coApplicantForm.controls['co_criteria'].disable();
      this.coApplicantForm.controls['co_email'].disable();
    }
  }
  Setvalue(org: any, field: any, cond: any) {
    switch (field) {
      case 'co_organizationName':
        this.organizationNameVal = cond == 'with' ? org.target.value : org;
        this.organizationNameVal = (this.organizationNameVal === undefined
          ? ''
          : this.organizationNameVal);
        break;
      case 'co_hightestRanking':
        this.hightestRankingVal = cond == 'with' ? org.target.value : org;
        this.hightestRankingVal =
          this.hightestRankingVal === undefined ? '' : this.hightestRankingVal;
        break;
      case 'co_Designation':
        this.designationVal = cond == 'with' ? org.target.value : org;
        this.designationVal = this.designationVal === undefined ? '' : this.designationVal
        break;
      case 'co_operationForm':
        this.co_operationFormVal = cond == 'with' ? org.target.value : org;
        this.co_operationFormVal =
          this.co_operationFormVal === undefined
            ? ''
            : this.co_operationFormVal;
        break;
      case 'co_operationEntityForm':
        this.co_operationEntityFormVal = cond == 'with' ? org.target.value : org;
        this.co_operationEntityFormVal =
          this.co_operationEntityFormVal === undefined
            ? ''
            : this.co_operationEntityFormVal;
        break;
      case 'co_email':
        this.co_emailVal = cond == 'with' ? org.target.value : org;
        this.co_emailVal =
          this.co_emailVal === undefined ? '' : this.co_emailVal;
        break;
    }
  }
  getAddress(e: any, field: any) {
    if (field === 'applicantAddress1') {
      this.AddressContact.address = e.target.value;
    } else if (field === 'applicantState') {
      this.AddressContact.state = e.target.value;
    } else if (field === 'applicantCity') {
      this.AddressContact.city = e.target.value;
    } else {
      this.AddressContact.pincode = e.target.value;
    }
  }
  clickFunction(status: boolean = false) {
    this.spinner.show();
    this.isValidFormSubmitted = false;
    if (this.coApplicantForm.invalid) {
      this.spinner.hide();
      this.FinalError.errMsg = 'Please check the highlighted fields.';
      this.FinalError.status = true;
      this.isValidFormSubmitted = true;
    } else {
      if (status && !this.udata.role.includes('admin')) {
        this.coApplicantForm.value['userStatus'] = true;
      }
      this.FinalError.errMsg = '';
      this.FinalError.status = false;
      this.coApplicantForm.value.co_organizationName = this.organizationNameVal;
      this.coApplicantForm.value.co_hightestRanking = this.hightestRankingVal;
      this.coApplicantForm.value.co_Designation = this.designationVal;
      this.coApplicantForm.value.co_operationForm = this.co_operationFormVal;
      this.coApplicantForm.value.co_operationEntityFormVal = this.co_operationEntityFormVal;
      this.coApplicantForm.value.co_email = this.co_emailVal;
      if (this.actionStatus == 'add') {
        this.coapplicantS
          .saveCoApplicant(this.coApplicantForm.value, this.udata.username)
          .subscribe((result: any) => {
            if (result.statusCode == 200) {
              this.toast.showSuccess(
                'Congratulation!, Co-Applicant has been added.'
              );
              this.spinner.hide();
            }
            if (!this.udata.role.includes('admin')) {
              this.router.navigate(['/applicant-dashboard']);
            }
          });
      } else {
        let formValue = this.coApplicantForm.value;
        if (this.udata.role.includes('admin')) {
          formValue = this.coApplicantForm.getRawValue()
        }
        this.coapplicantS
          .updateByIdCoApplicant(formValue, this.coapp_id)
          .subscribe((result: any) => {
            if (result.statusCode == 200) {
              this.toast.showSuccess(
                'Congratulation!, Co-Applicant has been updated.'
              );
              this.spinner.hide();
              if (!this.udata.role.includes('admin')) {
                this.router.navigate(['/applicant-dashboard']);
              }
            }
          });
      }
    }
  }
  getdistrict(e: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: e.target.value,
      })
      .subscribe((data: any) => {
        this.districtdata = data.result;
      });
  }
  getdistrictApplicant(e: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: e.target.value,
      })
      .subscribe((data: any) => {
        this.districtdataApplicant = data.result;
      });
  }
  getdistrictContact(e: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: e.target.value,
      })
      .subscribe((data: any) => {
        this.districtdataContact = data.result;
      });
  }
  getdistrictonload(state: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: state,
      })
      .subscribe((data: any) => {
        this.districtdata = data.result;
      });
  }
  getdistrictonloadApplicant(applicantState: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: applicantState,
      })
      .subscribe((data: any) => {
        this.districtdataApplicant = data.result;
      });
  }
  getdistrictonloadContact(contactState: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: contactState,
      })
      .subscribe((data: any) => {
        this.districtdataContact = data.result;
      });
  }
  getZipcodeData(e: any, evn: any) {
    let zipcode = evn == 'with' ? e.target.value : e;
    if (zipcode.length == 6) {
      this.locat.getZipcodeDetails(zipcode).subscribe((item: any) => {
        if (item.result.length != 0) {
          this.Applicant_city = item.result[0].Districtname;
          this.Applicant_state = item.result[0].statename;
          this.pinStatus = true;
          this.pinError = '';
        } else {
          this.Applicant_city = '';
          this.Applicant_state = '';
          this.pinError = 'Invalid Zip Code';
          this.pinStatus = false;
        }
      });
    } else {
      this.Applicant_city = '';
      this.Applicant_state = '';
      this.pinError = 'Invalid Zip Code';
      this.pinStatus = false;
    }
  }
  getZipcodeDataCon1(e: any, evn: any) {
    let zipcode = evn == 'with' ? e.target.value : e;
    if (zipcode.length == 6) {
      this.locat.getZipcodeDetails(zipcode).subscribe((item: any) => {
        if (item.result.length != 0) {
          this.con1_city = item.result[0].Districtname;
          this.con1_state = item.result[0].statename;
          this.con1Status = true;
          this.con1Error = '';
        } else {
          this.con1_city = '';
          this.con1_state = '';
          this.con1Error = 'Invalid Zip Code';
          this.con1Status = false;
        }
      });
    } else {
      this.con1_city = '';
      this.con1_state = '';
      this.con1Error = 'Invalid Zip Code';
      this.con1Status = false;
    }
  }
  finalSubmit() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to submit your application for review. Once submitted, you will not be able to make any changes.',
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, submit',
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.userStatus = true;
        this.coApplicantForm.disable()
        this.clickFunction(true);
      }
    });
  }
}
